"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = exports.default = {
  components: {
    UserAvatar: _UserAvatar.default,
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['network', 'buffer', 'user', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      whoisRequested: false,
      whoisLoading: false,
      inviteChan: '',
      pluginUiButtonElements: _GlobalApi.default.singleton().userboxButtonPlugins,
      pluginUiInfoElements: _GlobalApi.default.singleton().userboxInfoPlugins,
      pluginUiWhoisElements: _GlobalApi.default.singleton().userboxWhoisPlugins
    };
  },
  computed: {
    // Channel modes differ on some IRCds so get them from the network options
    availableChannelModes: function availableChannelModes() {
      var availableModes = [];
      var prefixes = this.network.ircClient.network.options.PREFIX;
      var knownPrefix = {
        q: 'Owner',
        a: 'Admin',
        o: 'Operator',
        h: 'Half-Operator',
        v: 'Voice'
      };
      prefixes.forEach(function (prefix) {
        var mode = prefix.mode;
        if (knownPrefix[mode]) {
          availableModes.push({
            mode: mode,
            description: knownPrefix[mode]
          });
        }
      });
      return availableModes;
    },
    areWeAnOp: function areWeAnOp() {
      if (!this.buffer) {
        return false;
      }
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    realname: function realname() {
      var _context;
      return (0, _trim.default)(_context = this.user.realname || '').call(_context);
    },
    formattedRealname: function formattedRealname() {
      var blocks = (0, _MessageParser.default)(this.realname, {
        extras: false
      });
      var content = (0, _Html.default)(blocks, false);
      return content;
    },
    isUserOnBuffer: function isUserOnBuffer() {
      if (!this.buffer) {
        return false;
      }
      if (!this.user.buffers[this.buffer.id]) {
        // Probably switched buffer while the userbox was open
        return false;
      }
      return true;
    },
    userMode: {
      get: function get() {
        if (!this.buffer) {
          return '';
        }
        var userBufferInfo = this.user.buffers[this.buffer.id];
        if (!userBufferInfo) {
          // Probably switched buffer while the userbox was open
          return '';
        }
        var modes = userBufferInfo.modes;
        return modes.length > 0 ? modes[0] : '';
      },
      // Switch the current user mode for the new one
      set: function set(newVal) {
        var _context2;
        var client = this.network.ircClient;
        var oldVal = this.userMode;
        var changes = [];
        var targets = [];
        if (oldVal) {
          changes.push('-' + oldVal);
          targets.push(this.user.nick);
        }
        if (newVal) {
          changes.push('+' + newVal);
          targets.push(this.user.nick);
        }
        var params = (0, _concat.default)(_context2 = ['MODE', this.buffer.name, changes.join('')]).call(_context2, targets);
        client.raw(params);
      }
    },
    userChannels: function userChannels() {
      var _context3, _context4;
      var channels = (0, _sort.default)(_context3 = (0, _trim.default)(_context4 = this.user.whois.channels).call(_context4).split(' ')).call(_context3, Misc.strCompare);
      for (var i = 0; i < channels.length; i++) {
        channels[i] = TextFormatting.linkifyChannels(channels[i]);
      }
      return channels.join(' ');
    },
    isSelf: function isSelf() {
      return this.user === this.network.currentUser();
    },
    invitableBuffers: function invitableBuffers() {
      var _this = this;
      var buffers = [];
      this.network.buffers.forEach(function (buffer) {
        if (buffer.isChannel() && buffer.isUserAnOp(_this.network.nick) && !buffer.hasNick(_this.user.nick)) {
          buffers.push(buffer.name);
        }
      });
      return buffers;
    }
  },
  watch: {
    user: function user() {
      // Reset the whois view since the user is now different
      this.whoisRequested = false;
      this.whoisLoading = false;
    }
  },
  methods: {
    openQuery: function openQuery() {
      this.sidebarState.showNicklist();
      var buffer = this.$state.addBuffer(this.network.id, this.user.nick);
      this.$state.setActiveBuffer(this.network.id, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('userbox.hide');
      }
    },
    onChannelsClick: function onChannelsClick(event) {
      var channelName = event.target.getAttribute('data-channel-name');
      if (channelName) {
        var network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
      }
    },
    updateWhoisData: function updateWhoisData() {
      var _this2 = this;
      this.whoisRequested = true;
      this.whoisLoading = true;
      this.network.ircClient.whois(this.user.nick, function () {
        _this2.whoisLoading = false;
      });
    },
    inviteUser: function inviteUser() {
      if (!this.inviteChan) {
        return;
      }
      this.network.ircClient.invite(this.inviteChan, this.user.nick);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserBox"]
window._kiwi_exports.components.UserBox = exports.default ? exports.default : exports;
